(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function tryBindCollectionListSlideIndicators(root) {
      const slideshow = root.querySelector('slideshow-component.resource-list__carousel');
      if (!slideshow) return;

      const nav = slideshow.querySelector('.collection-list__carousel-nav');
      const wrap = root.querySelector('[data-testid="collections-list-carousel"].collection-list--carousel-mobile-full');
      const track = wrap?.querySelector('.collection-list__slide-track');

      const getSlideCount = () => {
        const fromTrack = parseInt(track?.getAttribute('data-slide-count') || '0', 10);
        if (fromTrack > 0) return fromTrack;
        return slideshow.refs?.slides?.length || 0;
      };

      const isMobileNav = () => window.matchMedia('(max-width: 749px)').matches;

      const syncNavVisibility = (index) => {
        if (!nav || !isMobileNav()) return;

        const n = getSlideCount();
        if (!n) return;

        const i = Math.max(0, Math.min(typeof index === 'number' && !Number.isNaN(index) ? index : 0, n - 1));
        const prevBtn = nav.querySelector('.slideshow-control--previous');
        const nextBtn = nav.querySelector('.slideshow-control--next');
        const hiddenClass = 'is-collection-nav-hidden';
        const isFirst = i === 0;
        const isLast = i === n - 1;

        prevBtn?.classList.toggle(hiddenClass, isFirst);
        nextBtn?.classList.toggle(hiddenClass, isLast);
      };

      const resetNavVisibilityForDesktop = () => {
        if (!nav || isMobileNav()) return;

        nav.querySelectorAll('.slideshow-control').forEach((btn) => {
          btn.classList.remove('is-collection-nav-hidden');
        });
      };

      if (nav && nav.dataset.collectionNavBound !== '1') {
        nav.dataset.collectionNavBound = '1';
        slideshow.addEventListener('slideshow:select', (event) => {
          const idx = event.detail?.index;
          if (typeof idx === 'number') syncNavVisibility(idx);
        });
        window.matchMedia('(max-width: 749px)').addEventListener('change', () => {
          const cur = typeof slideshow.current === 'number' ? slideshow.current : 0;
          syncNavVisibility(cur);
          resetNavVisibilityForDesktop();
        });
      }

      if (!wrap || !track || wrap.dataset.collectionListIndicatorsBound === '1') {
        if (nav && nav.dataset.collectionNavBound === '1') {
          const initNav = () => {
            const cur = typeof slideshow.current === 'number' ? slideshow.current : 0;
            syncNavVisibility(cur);
            resetNavVisibilityForDesktop();
          };
          initNav();
          window.requestAnimationFrame(initNav);
          setTimeout(initNav, 350);
        }
        return;
      }

      const slideCount = getSlideCount();
      if (!slideCount) return;

      wrap.dataset.collectionListIndicatorsBound = '1';

      const sync = (index) => {
        const n = slideCount;
        const i = Math.max(0, Math.min(typeof index === 'number' && !Number.isNaN(index) ? index : 0, n - 1));
        track.style.setProperty('--collection-active-index', String(i));
        track.setAttribute('aria-valuenow', String(i + 1));
        track.setAttribute(
          'aria-valuetext',
          `${i + 1} / ${n}`
        );
        syncNavVisibility(i);
      };

      const onSelect = (event) => {
        const idx = event.detail?.index;
        if (typeof idx === 'number') sync(idx);
      };

      slideshow.addEventListener('slideshow:select', onSelect);

      track.addEventListener('click', (event) => {
        const n = slideCount;
        const rect = track.getBoundingClientRect();
        if (rect.width <= 0) return;
        const x = event.clientX - rect.left;
        const idx = Math.min(n - 1, Math.max(0, Math.floor((x / rect.width) * n)));
        slideshow.select(idx, event, { animate: true });
      });

      const initIndex = () => {
        const cur = typeof slideshow.current === 'number' ? slideshow.current : 0;
        sync(cur);
      };

      const initAllState = () => {
        initIndex();
        resetNavVisibilityForDesktop();
      };

      initAllState();
      window.requestAnimationFrame(initAllState);
      setTimeout(initAllState, 350);
    }

    function initAll() {
      document.querySelectorAll('.shopify-section.ui-test-collection-list').forEach((root) => {
        tryBindCollectionListSlideIndicators(root);
        window.requestAnimationFrame(() => tryBindCollectionListSlideIndicators(root));
        setTimeout(() => tryBindCollectionListSlideIndicators(root), 350);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const t = event.target;
      if (!t || !t.classList || !t.classList.contains('ui-test-collection-list')) return;

      const wrap = t.querySelector('[data-testid="collections-list-carousel"].collection-list--carousel-mobile-full');
      if (wrap) delete wrap.dataset.collectionListIndicatorsBound;
      t.querySelectorAll('.collection-list__carousel-nav').forEach((nav) => {
        delete nav.dataset.collectionNavBound;
      });

      tryBindCollectionListSlideIndicators(t);
      window.requestAnimationFrame(() => tryBindCollectionListSlideIndicators(t));
      setTimeout(() => tryBindCollectionListSlideIndicators(t), 350);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SECTION_ID_PART = 'section_GY3TPA';
    /** Horizontal position along the *painted* contain-fit media (0–1), then row is translateX(-50%) on this point. */
    const INLINE_FRACTION = 0.77;

    /**
     * object-fit:contain keeps intrinsic ratio inside the element box; layout width/height stay
     * full container — getBoundingClientRect on <img> is the box, not the drawn bitmap band.
     * Returns the painted rectangle in viewport coordinates (object-position default: center).
     */
    function getObjectFitContainViewportRect(media) {
      const box = media.getBoundingClientRect();
      const W = box.width;
      const H = box.height;
      if (W <= 0 || H <= 0) {
        return { left: box.left, width: W, top: box.top, height: H };
      }

      let nw = 0;
      let nh = 0;
      if (media instanceof HTMLImageElement) {
        nw = media.naturalWidth;
        nh = media.naturalHeight;
      } else if (media instanceof SVGSVGElement) {
        const vb = media.viewBox && media.viewBox.baseVal;
        if (vb && vb.width > 0 && vb.height > 0) {
          nw = vb.width;
          nh = vb.height;
        } else {
          try {
            const b = media.getBBox();
            if (b.width > 0 && b.height > 0) {
              nw = b.width;
              nh = b.height;
            }
          } catch (_e) {
            /* not laid out */
          }
        }
      }

      if (nw <= 0 || nh <= 0) {
        return { left: box.left, width: W, top: box.top, height: H };
      }

      const ar = nw / nh;
      const boxAr = W / H;
      let dw;
      let dh;
      let dx;
      let dy;
      if (ar > boxAr) {
        dw = W;
        dh = W / ar;
        dx = 0;
        dy = (H - dh) / 2;
      } else {
        dh = H;
        dw = H * ar;
        dx = (W - dw) / 2;
        dy = 0;
      }

      return {
        left: box.left + dx,
        width: dw,
        top: box.top + dy,
        height: dh,
      };
    }

    function updateRoot(root) {
      if (window.matchMedia('(min-width: 750px)').matches) return;

      const content = root.querySelector('.custom-section-content');
      const row = content?.querySelector(':scope > .section-content-wrapper.layout-panel-flex--row');
      const media = root.querySelector(
        '.custom-section-background .background-image-fit img, .custom-section-background .background-image-fit svg'
      );
      if (!content || !row || !media) return;

      const contentRect = content.getBoundingClientRect();
      const painted = getObjectFitContainViewportRect(media);
      if (painted.width <= 0) return;

      const paintedLeft = painted.left - contentRect.left;
      const anchorX = paintedLeft + INLINE_FRACTION * painted.width;
      row.style.left = `${anchorX}px`;
    }

    function bindRoot(root) {
      if (root.dataset.gy3FitAnchorBound === '1') {
        updateRoot(root);
        return;
      }
      root.dataset.gy3FitAnchorBound = '1';

      const run = () => {
        window.requestAnimationFrame(() => updateRoot(root));
      };

      run();

      const ro = new ResizeObserver(run);
      ro.observe(root);
      const content = root.querySelector('.custom-section-content');
      if (content) ro.observe(content);

      const media = root.querySelector(
        '.custom-section-background .background-image-fit img, .custom-section-background .background-image-fit svg'
      );
      if (media) {
        ro.observe(media);
        if (media instanceof HTMLImageElement && !media.complete) {
          media.addEventListener('load', run, { once: true });
        }
      }

      window.addEventListener('resize', run);
    }

    function initAll() {
      document.querySelectorAll('[id*="' + SECTION_ID_PART + '"]').forEach(bindRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
